import { PriceList, ProductMetadata, PlanProductModel } from "../models/products.models";

export class Product {
    constructor(private product: PlanProductModel) { }

    get data(): PlanProductModel {
        return this.product;
    }

    get id(): string {
        return this.product.id;
    }

    get name(): string {
        return this.product.name;
    };

    get advantages(): string[] {
        const metadata: ProductMetadata = this.product.metadata;
        return [
            metadata.avantage_1,
            metadata.avantage_2,
            metadata.avantage_3,
            metadata.avantage_4,
            metadata.avantage_5,
            metadata.avantage_6,
            metadata.avantage_7,
            metadata.avantage_8,
            metadata.avantage_9,
            metadata.avantage_10,
        ].filter((advantage): advantage is string => advantage !== undefined);
    }

    get defaultPrice(): string {
        return this.product.default_price
    }


    get color(): string {
        switch (this.product.name) {
            case 'Premium':
                return '#f29f79ff';
            case 'Entreprise':
                return '#B379F2';
            default:
                return "#47978bff";
        }
    }

    getMonthlyPrice(currency: string, periodicity: 'month' | 'year'): number {
        if (!this.product) throw new Error('No product for prices.')
        const prices: number[] = this.product.price_list
            .filter((price: PriceList) =>
                price.recurring.interval === periodicity
                && price.currency === currency.toLowerCase()
            ).map((p: PriceList) => periodicity === 'year' ? (p.unit_amount / 100) / 12 : p.unit_amount / 100)

        return prices.length > 0 ? prices[0] : 0;
    };

    getPricesIdByPerdiodicity(periodicity: 'month' | 'year'){
        if (!this.product) throw new Error('No product for prices.')
        const ids:string[] = this.product.price_list
        .filter((price:PriceList) => 
            price.recurring.interval === periodicity
        ).map((p: PriceList) => p.id)
        return ids.length > 0 ? ids[0] : 'ERROR';
    }
}